import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Card } from "../ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";

const fmt = (n) => `€ ${(n || 0).toFixed(2)}`;
const thisYear = new Date().getFullYear();
const years = [thisYear, thisYear - 1, thisYear - 2];

export default function VatPanel() {
  const [year, setYear] = useState(String(thisYear));
  const [data, setData] = useState(null);

  useEffect(() => { api.get(`/accounting/vat-summary?year=${year}`).then(({ data }) => setData(data)).catch(() => setData(null)); }, [year]);

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-muted-foreground">IVA a debito (incassi ufficiali) − IVA a credito (acquisti ufficiali) = IVA da versare</p>
        <div className="w-32">
          <Select value={year} onValueChange={setYear}>
            <SelectTrigger data-testid="vat-year-select"><SelectValue /></SelectTrigger>
            <SelectContent>{years.map((y) => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Card className="p-5 rounded-xl" data-testid="vat-total-debito"><span className="text-xs uppercase text-muted-foreground">IVA a debito {year}</span><p className="font-dash text-2xl font-semibold mt-3 text-sky-600">{fmt(data?.total_debito)}</p></Card>
        <Card className="p-5 rounded-xl" data-testid="vat-total-credito"><span className="text-xs uppercase text-muted-foreground">IVA a credito {year}</span><p className="font-dash text-2xl font-semibold mt-3 text-emerald-600">{fmt(data?.total_credito)}</p></Card>
        <Card className="p-5 rounded-xl border-primary/40" data-testid="vat-total-daversare"><span className="text-xs uppercase text-muted-foreground">IVA da versare {year}</span><p className={`font-dash text-2xl font-semibold mt-3 ${(data?.total_da_versare || 0) < 0 ? "text-emerald-600" : "text-destructive"}`}>{fmt(data?.total_da_versare)}</p></Card>
      </div>

      <Card className="rounded-xl overflow-hidden">
        <Table data-testid="vat-quarters-table">
          <TableHeader><TableRow><TableHead>Trimestre</TableHead><TableHead className="text-right">IVA a debito</TableHead><TableHead className="text-right">IVA a credito</TableHead><TableHead className="text-right">Da versare</TableHead></TableRow></TableHeader>
          <TableBody>
            {(data?.quarters || []).map((q) => (
              <TableRow key={q.quarter} data-testid={`vat-quarter-${q.quarter}`}>
                <TableCell className="font-medium">{q.label}</TableCell>
                <TableCell className="text-right">{fmt(q.iva_debito)}</TableCell>
                <TableCell className="text-right">{fmt(q.iva_credito)}</TableCell>
                <TableCell className={`text-right font-medium ${q.iva_da_versare < 0 ? "text-emerald-600" : ""}`}>{fmt(q.iva_da_versare)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
      <p className="text-xs text-muted-foreground">Nota: l'IVA a credito considera solo gli acquisti registrati come "Ufficiale" con aliquota IVA impostata.</p>
    </div>
  );
}
